import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appPriceAnimation]',
  standalone: true
})
export class PriceAnimationDirective implements AfterViewInit {
  private prices = [
    { yearly: 2399, monthly: 199 }, // Bundled Plan
    { yearly: 999, monthly: 99 },   // Peer Comparison
    { yearly: 1749, monthly: 145 }  // Non-Maturity Deposits
  ];

  private checkbox!: HTMLInputElement;
  private priceElements!: NodeListOf<HTMLElement>;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    const container = this.el.nativeElement;
    this.checkbox = container.querySelector('.signup__switch-toggle input[type="checkbox"]') as HTMLInputElement;
    this.priceElements = container.querySelectorAll('.signup__tier-price');

    if (this.checkbox) {
      this.checkbox.addEventListener('change', () => this.updatePricesAnimated());
      this.updatePricesAnimated(); // Initial update
    }
  }

  private easeOutQuad(t: number): number {
    return t * (2 - t);
  }

  private formatPrice(price: number): string {
    return price >= 1000 ? price.toLocaleString() : price.toString();
  }

  private animateCounting(
    element: HTMLElement,
    startPrice: number,
    endPrice: number,
    suffix: string,
    duration: number = 900
  ): void {
    let start: number | null = null;

    const step = (timestamp: number) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      const easing = this.easeOutQuad(progress);
      const currentPrice = Math.round(startPrice + (endPrice - startPrice) * easing);
      const formattedPrice = this.formatPrice(currentPrice);
      
      element.innerHTML = `$${formattedPrice}<span>${suffix}</span>`;

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  }

  private updatePricesAnimated(): void {
    const suffix = this.checkbox.checked ? '/yr' : '/mo.';

    this.priceElements.forEach((element, index) => {
      const currentText = element.textContent?.replace(/[^0-9]/g, '') || '0';
      const currentPrice = parseInt(currentText, 10);
      const targetPrice = this.checkbox.checked ? this.prices[index].yearly : this.prices[index].monthly;

      this.animateCounting(element, currentPrice, targetPrice, suffix);
    });
  }
}